/**
 * @generated SignedSource<<71f1aa80889a6cbe1e92dbccd55951c0>>
 * @relayHash 70027ad80f426267fbcd8bef55856d60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1b9e23cd051d45d3d1f762196ab684b44672e16dd778acf534a69dd3a9c11dd2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentLandingPageQuery } from './VirtualAgentLandingPageQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';
import showNextStepsEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-va-next-steps.relayprovider';
import vaStatusHeaderEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-va-status-header.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentLandingPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1b9e23cd051d45d3d1f762196ab684b44672e16dd778acf534a69dd3a9c11dd2",
    "metadata": {},
    "name": "VirtualAgentLandingPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": vaStatusHeaderEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvanextstepsrelayprovider": showNextStepsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
